(() => {
  if (window.cvPlaybookCoverFlipReady) return;
  window.cvPlaybookCoverFlipReady = true;

  const touchLikePointer = window.matchMedia('(hover: none), (pointer: coarse)');

  const setFlipped = (cover, flipped) => {
    cover.classList.toggle('is-flipped', flipped);

    if (cover.hasAttribute('aria-pressed')) {
      cover.setAttribute('aria-pressed', String(flipped));
      cover.setAttribute(
        'aria-label',
        flipped
          ? 'Show the front cover of The Student Athlete Playbook'
          : 'Show the back cover of The Student Athlete Playbook'
      );
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const cover = event.target.closest('[data-playbook-cover-flip]');
      if (!cover) return;

      const keyboardActivation = event.detail === 0;
      if (!touchLikePointer.matches && !keyboardActivation) return;

      if (cover.hasAttribute('data-playbook-cover-flip-nested')) {
        event.preventDefault();
        event.stopPropagation();
      }

      setFlipped(cover, !cover.classList.contains('is-flipped'));
    },
    true
  );
})();
